import Experience from "../../Experience";

export default class PartnersBannerBuilder {
    constructor() {
        this.experience = new Experience();
        this.data = [
            this.experience.router.main_data.data.main_partner_logo1,
            this.experience.router.main_data.data.main_partner_logo2,
            this.experience.router.main_data.data.main_partner_logo3,
            this.experience.router.main_data.data.main_partner_logo4,
            this.experience.router.main_data.data.main_partner_logo5,
            this.experience.router.main_data.data.main_partner_logo6,
            this.experience.router.main_data.data.main_partner_logo7,
            this.experience.router.main_data.data.main_partner_logo8,
            this.experience.router.main_data.data.main_partner_logo9,
        ].filter(Boolean)

        this.container = document.querySelector('.home-banner-container')
        this.cards = []
        this.speed = 0.18   // px per ms
        this.lastTime = null
        this._bound_tick = this._tick.bind(this)
        // offset is a single shared scroll position; card positions are derived from it
        this.offset = 0

        this.data.forEach((item) => {
            const card = document.createElement('div')
            card.className = 'partnerCard'
            card.style.cssText = `
                position: absolute;
                top: 0; left: 0;
                animation: none;
                display: flex;
                justify-content: center;
                align-items: center;
            `
            const img = document.createElement('img')
            img.src = item.url
            img.alt = ''
            card.appendChild(img)
            this.container.appendChild(card)
            this.cards.push(card)
        })

        // Reset lastTime on tab restore so we don't get a giant dt jump
        this._visibilityHandler = () => {
            if (document.visibilityState === 'visible') {
                this.lastTime = null
            }
        }
        document.addEventListener('visibilitychange', this._visibilityHandler)

        requestAnimationFrame(() => this._init())
    }

    _init() {
        if (!this.cards.length) return

        const cardW = this.cards[0].offsetWidth
        const gap   = 80   // px between cards
        this.slot   = cardW + gap
        this.cardW  = cardW
        this.totalStrip = this.slot * this.cards.length

        // Start offset so cards fill the screen from the left immediately.
        // Each card's x = (i * slot - offset) mod totalStrip.
        // We want card 0 to start at 0 (left edge of screen).
        this.offset = 0
        this._applyPositions()

        requestAnimationFrame(this._bound_tick)
    }

    _applyPositions() {
        // Each card sits at a fixed index in the strip.
        // The strip loops: card i is at position (i * slot - offset),
        // then wrapped into [-(cardW) .. totalStrip] so it cycles seamlessly.
        this.cards.forEach((card, i) => {
            let x = i * this.slot - this.offset
            // Wrap into the visible window range
            x = ((x % this.totalStrip) + this.totalStrip) % this.totalStrip
            // Shift so some cards start left of screen and some start right
            // We want x in range [-(cardW) .. totalStrip - cardW]
            // Keep as-is — cards start from 0 and go right, loop around
            card.style.transform = `translateX(${x}px)`
        })
    }

    _tick(now) {
        if (this.lastTime === null) {
            this.lastTime = now
            requestAnimationFrame(this._bound_tick)
            return
        }

        const dt = Math.min(now - this.lastTime, 100)
        this.lastTime = now

        this.offset += this.speed * dt
        // Keep offset from growing forever
        this.offset = this.offset % this.totalStrip

        this._applyPositions()

        requestAnimationFrame(this._bound_tick)
    }
}
